import _ from 'lodash';
import { Common } from './common';
import { Component } from './component';
import { Home } from './features/Home';

(function () {
  window.addEventListener('DOMContentLoaded', () => {
    Common.init();
    Component.init();
    Home.init();
  });

  const handleResize = _.debounce(() => {
    Common.resize();
  });
  window.addEventListener('resize', handleResize);
  const handleScroll = _.debounce(() => {
    Common.scroll();
  });
  window.addEventListener('scroll', handleScroll);

  window.addEventListener('breakPoint', () => {
    Common.breakPoint();
  });
})();
